import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { ADMISSION_CONFIG } from "../../constants/admissionConfig";
import AdmissionDate from "../common/AdmissionDate";

const HomeAdmission = () => {

  // timer
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [isClosed, setIsClosed] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const targetDate = new Date(ADMISSION_CONFIG.deadlineFull).getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsClosed(true);
      } else {
        setIsClosed(false);
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [ADMISSION_CONFIG.deadlineFull]);

  if (!mounted) {
    return null; // Prevent hydration mismatch
  }

  return (
    <section className="home-admission">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="single-addmission">
              <div className="row align-items-center">
                {/* Left Circle */}
                <div className="col-xl-4 col-md-5">
                  <div className="admission-circle">
                    {/* <h2>
                      Admission <span>{isClosed ? "Closed" : "on Going"}</span>
                    </h2> */}
                    <h2 className="late-text">Admission open for late registration</h2>

                    <div className="admission-shape1">
                      <Image src="/images/admission/shape1.png" alt="shape" width={25} height={25} />
                    </div>

                    <div className="admission-shape2">
                      <Image src="/images/admission/shape2.png" alt="shape" width={25} height={25} />
                    </div>

                    <div className="admission-shape3">
                      <Image src="/images/admission/shape3.png" alt="shape" width={45} height={28} />
                    </div>

                    <div className="admission-shape4">
                      <Image src="/images/admission/shape4.png" alt="shape" width={45} height={28} />
                    </div>
                  </div>
                </div>

                {/* Right Content */}
                <div className="col-xl-8 col-md-7">
                  <div className="admission-content">
                    <h2>Admission for <AdmissionDate type="academicYear" /> school year for all students</h2>
                    <p>
                      {isClosed ? (
                        <span className="text-warning fw-bold">We are now open for late registration: office hours 9:00 AM to 3:00 PM</span>
                      ) : (
                        <>Registration will Close <AdmissionDate type="deadline" />. Time Remaining:</>
                      )}
                    </p>

                    {!isClosed ? (
                      <ul className="admission-list">
                        <li>
                          <p>{timeLeft.days}</p>
                          <span>Days</span>
                        </li>
                        <li>
                          <p>{timeLeft.hours}</p>
                          <span>Hours</span>
                        </li>
                        <li>
                          <p>{timeLeft.minutes}</p>
                          <span>Minutes</span>
                        </li>
                        <li>
                          <p>{timeLeft.seconds}</p>
                          <span>Seconds</span>
                        </li>
                      </ul>
                    ) : (
                      <div className="admission-closed-msg mt-4">
                        <p>If you have any queries, please visit our contact page or call us directly.</p>
                      </div>
                    )}

                    {!isClosed && (
                      <Link href="/admission" className="box-btn">
                        Admission Now
                      </Link>
                    )}
                    {isClosed && (
                      <Link href="/contact" className="box-btn">
                        Contact Us
                      </Link>
                    )}
                  </div>
                </div>
              </div>


              {/* Floating Shape */}
              <span className="loon">
                <Image
                  src="/images/admission/shape5.png"
                  alt="shape"
                  width={120}
                  height={120}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAdmission;

